const FAMILY_ACCOUNT_RETURN_URL_STORAGE_KEY = 'familyAccountReturnUrl'
const ABORTED_ORDER_ID_STORAGE_KEY = 'abortedOrderUuid'
const STEPPER_STORAGE_KEY = 'stepperMapping'
const SUCCESSFUL_CONFIRMATION = 'successfulConfirmation'

export const getItem = (key: string) => window.sessionStorage.getItem(key)
export const removeItem = (key: string) => window.sessionStorage.removeItem(key)
export const setItem = (key: string, value: string) => {
  window.sessionStorage.setItem(key, value)
}
class SessionUtils {
  private static instance: SessionUtils

  private constructor() {}

  public static getInstance(): SessionUtils {
    if (!SessionUtils.instance) {
      SessionUtils.instance = new SessionUtils()
    }

    return SessionUtils.instance
  }

  public setFamilyAccountReturnUrl = (value: string) => {
    setItem(FAMILY_ACCOUNT_RETURN_URL_STORAGE_KEY, value)
  }

  public setAbortedOrderId = (orderId: string) => {
    setItem(ABORTED_ORDER_ID_STORAGE_KEY, orderId)
  }

  public setStepper = (stepper: any) => {
    setItem(STEPPER_STORAGE_KEY, JSON.stringify(stepper))
  }

  public setConfirmationWasSuccessful = () => {
    setItem(SUCCESSFUL_CONFIRMATION, 'true')
  }

  public removeAbortedOrderId = () => removeItem(ABORTED_ORDER_ID_STORAGE_KEY)
  public removeStepper = () => removeItem(STEPPER_STORAGE_KEY)
  public removeConfirmationWasSuccessful = () => removeItem(SUCCESSFUL_CONFIRMATION)

  public getFamilyAccountReturnUrl = () => getItem(FAMILY_ACCOUNT_RETURN_URL_STORAGE_KEY)
  public getAbortedOrderId = () => getItem(ABORTED_ORDER_ID_STORAGE_KEY)
  public getConfirmationWasSuccessful = () => getItem(SUCCESSFUL_CONFIRMATION)
  public getStepper = () => {
    const stepper = getItem(STEPPER_STORAGE_KEY)

    if (!stepper) return null
    return JSON.parse(stepper)
  }
}

const sessionUtils = SessionUtils.getInstance()

export default sessionUtils
